import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Content } from './content';

const FeatureMedia = styled.div``;
const FeatureSection = styled.section<{ reverse? }>`
  display: flex;
  ${ifProp(
    'reverse',
    css`
      flex-direction: row-reverse;
    `,
  )};
  gap: var(--spacing-05);

  ${FeatureMedia},
  ${Content} {
    width: 50%;
    flex: 1;
    > * {
      max-width: 100%;
    }
  }
  ${FeatureMedia} {
    margin-bottom: var(--spacing-08);
  }
`;

type Section = typeof FeatureSection & {
  Content: typeof Content;
  Media: typeof FeatureMedia;
};

const Section: Section = FeatureSection as any;

Section.Content = Content;
Section.Media = FeatureMedia;

export { Section };
